
/** @type {string} */
export const currentPageClass = "current_page";

/** @type {string} */
export const mobileNavIsActiveClass = 'mobile__nav--active';

/** @type {string} */
export const searchIsActiveClass = 'header__search--active';

/** @type {string} */
export const delayLoadClass = 'page-loading';
